import React from "react"
import styled from "styled-components"
import media from "../styles/media"
import colors from "../styles/colors"
import ContentWidth from "./ContentWidth"
import StyledLink from "./StyledLink"
import text from "styles/text"

const Cards = ({ content, index }) => {
  const allCards = content.columns.map(card => (
    <Column key={card.cardSubhead}>
      <Card>
        <StyledImg
          alt={content?.icon?.altText}
          centered={content.centered}
          src={card?.icon?.sourceUrl}
        />
        <BodyDiv>
          <CardEyebrow>{card?.cardEyebrow}</CardEyebrow>
          <CardHeader dangerouslySetInnerHTML={{ __html: card?.headline }} />
          <Body dangerouslySetInnerHTML={{ __html: card?.bodyCopy }} />
          {card?.link && (
            <StyledLink href={card?.link} bottom>
              {" "}
              Check it out{" "}
            </StyledLink>
          )}
        </BodyDiv>
      </Card>
    </Column>
  ))

  return (
    <ContentWidth>
      <Container>
        <Eyebrow>{content?.eyebrow}</Eyebrow>
        <Header>{content?.headline}</Header>
        <BodyText>{content?.body}</BodyText>
        <Rows>{allCards}</Rows>
      </Container>
    </ContentWidth>
  )
}
const BodyText = styled.p`
  ${text.bodyMd};
  width: 63.333vw;
  margin-bottom: 4.167vw;
  text-align: center;

  ${media.fullWidth} {
    margin-bottom: 60px;
    width: 912px;
  }
  ${media.tablet} {
    width: 80.469vw;
    margin-bottom: 3.906vw;
  }
  ${media.mobile} {
    width: 87.85vw;
    margin-bottom: 9.346vw;
  }
`
const CardEyebrow = styled.p`
  font-family: Archivo;
  font-size: 0.972vw;
  line-height: 1.25vw;
  letter-spacing: 0.222vw;
  font-weight: 800;
  text-align: left;
  color: ${colors.grey500};
  text-transform: uppercase;

  ${media.fullWidth} {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 3.2px;
  }
  ${media.tablet} {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 3.2px;
  }
  ${media.mobile} {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 3.2px;
  }
`
const Eyebrow = styled.p`
  ${text.eyebrow};
  margin-bottom: 1.667vw;
  ${media.fullWidth} {
    margin-bottom: 24px;
  }
  ${media.tablet} {
    margin-bottom: 2.344vw;
  }
  ${media.mobile} {
    margin-bottom: 4.673vw;
  }
`
const BodyDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 20.833vw;
  padding: 1.389vw 0.694vw 1.042vw 0.694vw;
  gap: 0.694vw;
  background-color: white;

  ${media.fullWidth} {
    height: 300px;
    padding: 20px 10px 15px 10px;
    gap: 10px;
  }

  ${media.tablet} {
    height: 100%;
    padding: 1.953vw 2.93vw 0.977vw 2.93vw;
    gap: 0.977vw;
  }

  ${media.mobile} {
    height: auto;
    padding: 4.673vw 2.667vw 4vw 2.667vw;
    gap: 2.667vw;
  }
`
const StyledImg = styled.img`
  height: 12.639vw;
  width: 19.097vw;

  ${media.fullWidth} {
    height: 182px;
    width: 100%;
  }

  ${media.tablet} {
    height: 16.895vw;
    width: 100%;
    align-self: center;
  }

  ${media.mobile} {
    align-self: center;
    width: 100%;
    height: 50.682vw;
  }
`
const Body = styled.div`
  p {
    font-family: Archivo, sans;
    color: ${colors.grey700};
    font-size: 1.25vw;
    line-height: 1.875vw;

    ${media.fullWidth} {
      font-size: 18px;
      line-height: 27px;
    }

    ${media.tablet} {
      font-size: 1.758vw;
      width: 19.629vw;
      line-height: 2.637vw;
    }

    ${media.mobile} {
      font-size: 4vw;
      line-height: 5.333vw;
      max-width: unset;
      margin-bottom: 11.682vw;
    }
  }
`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 24.583vw;
  height: 100%;
  box-shadow: 0.139vw 0.139vw 0.694vw ${colors.grey50};
  overflow: hidden;
  border-radius: 0.972vw;

  ${media.fullWidth} {
    height: 100%;
    width: 354px;
    box-shadow: 2px 2px 10px ${colors.grey50};
    border-radius: 14px;
  }

  ${media.tablet} {
    width: 29.297vw;
    height: 100%;
    box-shadow: 0.195vw 0.195vw 0.977vw ${colors.grey50};
    border-radius: 1.367vw;
  }

  ${media.mobile} {
    height: auto;
    width: 87.85vw;
    box-shadow: 0.533vw 0.533vw 2.667vw ${colors.grey50};
    border-radius: 3.271vw;
  }

  ${media.hover} {
    &:hover {
      scale: 1.1;
      transition-duration: 0.3s;
      cursor: pointer;
    }
  }
`
const CardHeader = styled.h4`
  font-family: Archivo;
  font-size: 1.389vw;
  font-weight: 700;
  line-height: 1.667vw;
  letter-spacing: 0em;
  text-align: left;

  ${media.fullWidth} {
    font-size: 20px;
    line-height: 24px;
  }

  ${media.tablet} {
    font-size: 2.344vw;
    line-height: 2.93vw;
    font-weight: 700;
    margin-bottom: 1.953vw;
  }

  ${media.mobile} {
    font-size: 5.333vw;
    line-height: 6.667vw;
  }
`
const Header = styled.h2`
  color: ${colors.grey800};
  ${text.h2};
  text-align: center;
  margin-bottom: 1.389vw;

  ${media.fullWidth} {
    margin-bottom: 20px;
  }

  ${media.tablet} {
    margin-bottom: 1.953vw;
  }

  ${media.mobile} {
    text-align: center;
    width: 80vw;
    margin-bottom: 4.673vw;
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media.tablet} {
    height: auto;
  }
`
const Rows = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  height: auto;
  width: 100%;
  gap: 2.083vw 1.389vw;

  ${media.fullWidth} {
    width: 1440px;
  }

  ${media.tablet} {
    width: 100vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 4.673vw;
    width: 80vw;
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;

  ${media.fullWidth} {
    height: auto;
  }

  ${media.tablet} {
    height: auto;
  }

  ${media.mobile} {
    height: auto;
    padding-bottom: 35vw;
  }
`
export default Cards
